import { HttpClient } from '../../httpClient'
import { throwIfNotAllowedContentType, validateHttpResponse } from '../../httpClient/utils.ts'

interface IPublicOrganization {
	name: string
}

export const getOrganizationPublic = async (client: HttpClient, organizationId: string): Promise<IPublicOrganization> => {
	const response = await client.get<IPublicOrganization>(`/api/public/organizations/${organizationId}`)

	await validateHttpResponse(response)
	throwIfNotAllowedContentType(response, ['application/json'])

	return response.data
}
